import React from 'react';

import { AtlasReport } from '../../sub/mcsa/report/AtlasReport';

export const MCSAReport = () => {
    return (
        <div className='mcsa_report__page'>
            <AtlasReport />
        </div>
    );
};
